module.exports = __webpack_public_path__ + "media/images/feder-b207ff44401b6f58a723579802e1a785.png";